import { StyledSection } from './styles';
import { SectionProps } from './types';

export const Section: React.FC<SectionProps> = ({ image, sectionName }) => {
  return (
    <StyledSection data-testid={sectionName}>
      <img src={image} alt="section" />
    </StyledSection>
  );
};
